import { Anchor } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { readLinkTrail } from 'src/Components/EntityLinks/utils/linkTrail';
import { trackLinkTrailBackClicked } from 'src/Services/Mixpanel/events';

import styles from './LinkTrail.module.scss';

/**
 * "Vous venez de" breadcrumb shown on top of a fiche reached through the "Lié à" panel.
 * Renders nothing when the fiche was opened any other way.
 */
const LinkTrail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const trail = readLinkTrail(location.state);

  if (trail.length === 0) return null;

  return (
    <nav className={styles.container} aria-label={t('entityLinks.trail.label', 'Vous venez de')}>
      <span className={styles.label}>{t('entityLinks.trail.label', 'Vous venez de')} :</span>
      {trail.map((step, index) => (
        <span key={`${step.type}-${step.id}-${index}`} className={styles.step}>
          {index > 0 && <IconChevronRight size={14} className={styles.separator} />}
          <Anchor
            component="button"
            type="button"
            size="sm"
            onClick={() => {
              trackLinkTrailBackClicked({
                target_entity_type: step.type,
                steps_back: trail.length - index,
              });
              navigate(step.path, { state: { linkTrail: trail.slice(0, index) } });
            }}
          >
            {step.title}
          </Anchor>
        </span>
      ))}
    </nav>
  );
};

export default LinkTrail;
